import { ACCOUNT_CONDITION } from "../const/conditions";
var isLoanClosed = function (conditions) {
    return conditions.includes(ACCOUNT_CONDITION.CLOSED);
};
export default isLoanClosed;
//# sourceMappingURL=isLoanClosed.js.map